import { Snackbar, Alert } from '@mui/material';

const Toast = ({ open, message, severity, onClose }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{ mt: 8 }}
    >
      <Alert 
        onClose={onClose} 
        severity={severity} 
        sx={{ 
          width: '100%',
          borderRadius: 2,
          '& .MuiAlert-icon': {
            fontSize: '2rem'
          }
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default Toast;